import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader, MenuSection } from "../../MenuCard";

const ITEMS = [
  { type: "section", label: "Disponible" },
  { label: "Disponible", icon: "fas fa-tasks", color: "#10b981", bg: "#f0fdf4", href: "/ListadoDisponible", desc: "Disponible por artículo", perm: "menu_disponible" },
  { label: "Disponible Vendedor", icon: "fas fa-tasks", color: "#3b82f6", bg: "#eff6ff", href: "/ListadoDisponibleVendedor", desc: "Disponible para vendedores", perm: "disponible_vendedores" },
];

function BotonesDisponibles() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-tasks" color="#0ea5e9" bg="#f0f9ff" title="Disponibles" subtitle="Existencia disponible para venta" />
        {user.menu_inventarios ? (
          <div className="row">
            {ITEMS.map((r, i) =>
              r.type === "section"
                ? <MenuSection key={i} title={r.label} />
                : <MenuCard key={i} {...r} enabled={!!user[r.perm]} />
            )}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesDisponibles;
